import { createContext as t } from "react";
const o = t({
  value: "",
  setTitleNode: () => {
  },
  setActiveIndex: () => {
  }
});
export {
  o as DonutChartContext
};
